import type { ReactNode } from 'react';

import { cn } from '@nesso/ui/lib/utils';

type PageTitleProps = {
    children: ReactNode;
    className?: string;
};

export function PageTitle({ children, className }: PageTitleProps) {
    return <h1 className={cn('font-bold text-2xl', className)}>{children}</h1>;
}
